import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SharedModule } from './shared/shared.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {LoginComponent} from "./+login/login.component";
import {SiteAppModule} from "./+site-app/site-app.module";
import {AdminAppModule} from "./+admin-app/admin-app.module";

@NgModule({
  declarations: [ AppComponent, LoginComponent ],
  imports: [
    SharedModule,
    SiteAppModule,
    AdminAppModule,
    AppRoutingModule
  ]
})
export class AppModule {
}

export { AppComponent } from './app.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/app.module.ts